import React, { useContext, useRef, useState } from "react";
import { Button } from "primereact/button";
import { LayoutContext } from "../../layout/context/layoutcontext";
import { Link, useNavigate } from "react-router-dom";
import { Carousel } from "primereact/carousel";
import "../../assets/styles/hover.scss";
import { Menu } from "primereact/menu";
import "../../assets/styles/hover.scss";
import { useAuth } from "../../utils/auth";
import authService from "../../services/auth/auth.service";
import Header from "./Header";

interface ItemDto {
  name: string;

  description: string;

  image: string;

  link: string;

  documentPath?: string;
}

const cardData = [
  {
    imgSrc: "/images/landing-page/hesaplama.jpg",

    title: "Hesaplama",

    description: "Yeşil dönüşüm ve sürdürülebilirlik politikalarınızı planlamak için gerekli hesaplamalar",

    path: "/app/karbonayakizi"
  },

  {
    imgSrc: "/images/landing-page/rapor.jpg",

    title: "Raporlama",

    description: "Sürdürülebilirlik, çevresel performans, iyileştirme ve malzeme-kaynak yönetimi raporları",

    path: "/app/rapor"
  },

  {
    imgSrc: "/images/landing-page/analiz.jpg",

    title: "Analiz",

    description:
      "Yeşil dönüşüm olgunluk analizi, dijital dönüşüm endeksi ve sektör/bölge/ülke genelindeki istatistikler ve raporlar",

    path: "/app/grafik"
  },

  {
    imgSrc: "/images/landing-page/egitim.jpg",

    title: "Eğitim",

    description: "Sürdürülebilirlik, yenilikçilik, teknoloji, kurumsal gelişim ve iklim değişikliğine uyum eğitimleri",

    path: "/app/egitim"
  },

  {
    imgSrc: "/images/landing-page/afad.jpg",

    title: "İş Sürekliliği Planı",

    description:
      "Afet durumunda sanayi kuruluşlarının kesintisiz faaliyet göstermesi için AFAD ve Sanayi Bakanlığı ile geliştirdiğimiz iş birliği çalışmaları",

    path: "/app/is-surekliligi"
  },

  {
    imgSrc: "/images/landing-page/haber.jpg",

    title: "OSBÜK Bülten",

    description: "Türkiye'deki organize sanayi bölgeleriyle ilgili güncel haberler, projeler ve sektörel gelişmeler",

    path: "/app/bulten"
  }
];

const crouselItems: any = [
  {
    name: "Stratejik Plan Raporu",

    description: "Paydaş beklenti ve ihtiyaç analizi (2.10.2024)",

    image: "/images/landing-page/stratejikplan.jpg",

    documentPath: "/belgeler/strateji-belge.pdf"
  },

  {
    name: "Stratejik Plan Çalışması",

    description: "Stratejik plan çalışmaları ve değerlendirmeler",

    image: "/images/landing-page/stratejik-plan.jpg",

    link: "/app/stratejik-plan"
  },

  {
    name: "Forum",

    description: "Forum",

    image: "/images/landing-page/forum.jpg",

    link: "/app/forum-homepage"
  },

  {
    name: "Hesaplama",

    description: "Gerekli hesaplamalara buradan ulaşabilirsiniz.",

    image: "/images/landing-page/hesaplama.jpg",

    link: "/app/karbonayakizi"
  },

  {
    name: "Raporlama",

    description: "Sürdürülebilirlik ve çevresel performans raporları.",

    image: "/images/landing-page/rapor.jpg",

    link: "/app/rapor"
  },

  {
    name: "Analiz",

    description: "Yeşil dönüşüm olgunluk analizi ve istatistikler.",

    image: "/images/landing-page/analiz.jpg",

    link: "/app/grafik"
  },

  {
    name: "Eğitim",

    description: "Geniş kapsamlı eğitim fırsatları",

    image: "/images/landing-page/egitim.jpg",

    link: "/app/egitim"
  },

  {
    name: "İş Sürekliliği",

    description: "Amaçlar çalıştay çalışmaları (31 Ekim - 3 Kasım 2024)",

    image: "/images/landing-page/afad.jpg",

    link: "/app/is-surekliligi"
  },

  {
    name: "OSBÜK Bülten",

    description: "Güncel OSB haberleri bülteni",

    image: "/images/landing-page/haber.jpg",

    link: "/app/bulten"
  }
];

const LandingPage = () => {
  const [isHidden, setIsHidden] = useState(false);

  const { layoutConfig } = useContext(LayoutContext);

  const menuRef = useRef<HTMLElement | null>(null);
  const profileMenu = useRef<Menu>(null);

  const navigate = useNavigate();

  const auth = useAuth();

  const toggleMenuItemClick = () => {
    setIsHidden((prevState) => !prevState);
  };

  const handleDownload = (documentPath: string) => {
    const link = document.createElement("a");
    link.href = documentPath;
    link.download = documentPath.split("/").pop() || "document.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const itemTemplate = (item: ItemDto) => {
    const handleClick = (e: React.MouseEvent) => {
      e.preventDefault();
      if (item.name === "Stratejik Plan Raporu" && item.documentPath) {
        window.open(item.documentPath, "_blank");
      } else if (item.link) {
        navigate(item.link);
      }
    };

    return (
      <a
        href={item.link || "#"}
        onClick={handleClick}
        className="border-round-2xl border-3 border-primary-500 surface-border border-round m-2 text-center py-3 px-3 h-auto block transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-3"
      >
        <div className="mb-3">
          <img src={item.image} alt={item.name} className="w-8rem h-8rem object-cover rounded-full mx-auto shadow-2" />
        </div>

        <div className="text-center">
          <h4 className="mb-2 text-xl font-semibold" style={{ maxHeight: "2em", minHeight: "2em" }}>
            {item.name}
          </h4>

          <p
            className="text-sm overflow-hidden text-ellipsis line-clamp-2"
            style={{ maxHeight: "3em", minHeight: "3em" }}
          >
            {item.description}
          </p>
        </div>
      </a>
    );
  };

  const responsiveOptions = [
    {
      breakpoint: "1024px",

      numVisible: 5,

      numScroll: 5
    },

    {
      breakpoint: "768px",

      numVisible: 2,

      numScroll: 2
    },

    {
      breakpoint: "560px",

      numVisible: 1,

      numScroll: 1
    }
  ];

  //const username = localStorage.getItem("userName");

  const [menuVisible, setMenuVisible] = useState(false);

  const items = [
    {
      label: "Giriş Yap",

      icon: "pi pi-sign-in",

      command: () => navigate("/loginsebis"),

      visible: !auth.getUser().access_token
    },

    {
      label: "Kayıt Ol",

      icon: "pi pi-user-plus",

      command: () => {
        auth.removeUserFromStorage();

        navigate("/register", { replace: true });
      },

      visible: !auth.getUser().access_token
    }
  ];

  const profileItems = [
    {
      label: "Profil",
      icon: "pi pi-user",
      command: () => {
        navigate("/app/profile");
      }
    },
    {
      label: "Ana Sayfa",
      icon: "pi pi-home",
      command: () => {
        navigate("/app/homepage");
      }
    },
    {
      label: "Çıkış Yap",
      icon: "pi pi-sign-out",
      command: async () => {
        await authService.RevokeRefreshToken({ token: auth.getUser().refresh_token });
        auth.removeUserFromStorage();
        navigate("/loginsebis", { replace: true });
      }
    }
  ];

  const [sliderItems, setSliderItems] = useState<ItemDto[]>([]);

  return (
    <div className="surface-0 flex justify-content-center">
      <div id="home" className="landing-wrapper overflow-hidden w-full">
        {/* Navigation Bar */}
        <header className="py-2 px-2 sm:px-4 md:px-6 flex align-items-center justify-content-between surface-overlay border-bottom-1 surface-border sticky top-0 z-5 shadow-1">
          <Link to="/" className="flex align-items-center flex-shrink-0">
            <img src="/images/logoosbuk.png" alt="OSBÜK Logo" className="mr-1" style={{ height: "32px", width: "auto", objectFit: "contain" }} />
          </Link>

          <div className="flex align-items-center gap-1 sm:gap-2 flex-shrink-0">
            {!auth.getUser().access_token ? (
              <div className="flex align-items-center gap-1 sm:gap-2">
                <Button
                  label="Giriş Yap"
                  outlined
                  rounded
                  size="small"
                  className="font-medium px-2 sm:px-3 text-xs sm:text-sm text-primary"
                  onClick={() => navigate("/loginsebis")}
                />
                <Button
                  label="Kayıt Ol"
                  rounded
                  size="small"
                  className="font-medium px-2 sm:px-3 text-xs sm:text-sm"
                  onClick={() => navigate("/register")}
                />
              </div>
            ) : (
              <div className="flex align-items-center gap-2">
                <span className="font-semibold text-sm text-900 hidden sm:inline">
                  {[auth.getUser()?.firstName, auth.getUser()?.lastName].filter(Boolean).join(" ")}
                </span>
                <Menu model={profileItems} popup ref={profileMenu} />
                <Button
                  label="Profilim"
                  icon="pi pi-user"
                  rounded
                  outlined
                  size="small"
                  onClick={(e) => profileMenu.current?.toggle(e)}
                />
              </div>
            )}
          </div>
        </header>

        {/* Hero Section */}
        <Header />

        {/* Quick Access Highlights */}
        <section className="py-5 px-3 sm:px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="text-center mb-4">
            <h2 className="text-900 font-bold text-2xl md:text-3xl mb-2">Hızlı Erişim</h2>
            <p className="text-600 text-sm md:text-base m-0">Merkezin sunduğu temel hizmet ve modüllere doğrudan ulaşın</p>
          </div>
          <div className="grid">
            {cardData.map((card, index) => (
              <div className="col-12 sm:col-6 lg:col-4 p-2" key={index}>
                <div
                  className="surface-card border-1 surface-border border-round-xl p-3 h-full cursor-pointer hover:shadow-3 hover:border-primary transition-all transition-duration-200 flex align-items-center gap-3"
                  style={{ minHeight: "110px" }}
                  onClick={() => navigate(card.path)}
                  role="button"
                  tabIndex={0}
                >
                  <img
                    src={card.imgSrc}
                    className="border-round-lg flex-shrink-0"
                    style={{ width: "64px", height: "64px", objectFit: "cover" }}
                    alt={card.title}
                    loading="lazy"
                  />
                  <div className="flex-1 overflow-hidden">
                    <h3 className="mb-1 text-900 text-base font-bold">{card.title}</h3>
                    <p className="text-600 text-xs line-clamp-2 m-0 leading-normal">{card.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* President Message Banner */}
        <section className="py-2 px-3 sm:px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
          <div
            className="border-round-2xl p-2 sm:p-4 text-center cursor-pointer hover:shadow-2 transition-shadow"
            style={{
              background: "linear-gradient(135deg, rgba(239, 246, 255, 0.8) 0%, rgba(219, 234, 254, 0.8) 100%)",
              border: "1px solid #bfdbfe"
            }}
            onClick={() => navigate("/app/baskan-mesaj")}
          >
            <img
              src="images/baskanmesajnew.png"
              alt="Başkanın Mesajı"
              className="w-full h-auto border-round-xl"
              style={{ maxHeight: "380px", objectFit: "contain" }}
              loading="lazy"
            />
          </div>
        </section>

        {/* Carousel Showcase */}
        <section className="py-5 px-3 sm:px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="surface-card border-1 surface-border border-round-2xl p-3 sm:p-4 shadow-1">
            <div className="text-center mb-3">
              <h3 className="text-900 font-bold text-xl md:text-2xl m-0">Öne Çıkan Çalışmalar</h3>
            </div>
            <Carousel
              value={crouselItems}
              numVisible={5}
              responsiveOptions={responsiveOptions}
              circular
              autoplayInterval={3500}
              itemTemplate={itemTemplate}
            />
          </div>
        </section>

        {/* Community & Interactive Modules */}
        <section className="py-5 px-3 sm:px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="text-center mb-5">
            <h2 className="text-900 font-bold text-2xl md:text-3xl mb-2">Topluluk ve Bilgi Paylaşımı</h2>
            <p className="text-600 text-sm md:text-base m-0">
              OSBÜK ve diğer sanayi paydaşlarıyla bilgi alışverişi yapın ve sektörel gelişmeleri takip edin
            </p>
          </div>

          {/* Module 1: Forum */}
          <div className="grid align-items-center mb-5 surface-card border-1 surface-border border-round-2xl p-3 sm:p-5 shadow-1">
            <div className="col-12 lg:col-6 text-center lg:text-left mb-3 lg:mb-0">
              <div
                className="inline-flex align-items-center justify-content-center bg-cyan-100 border-round-xl mb-3"
                style={{ width: "3.5rem", height: "3.5rem" }}
              >
                <i className="pi pi-comments text-3xl text-cyan-700"></i>
              </div>
              <h3 className="text-900 text-2xl font-bold mb-2">Paydaş Forumu</h3>
              <p className="text-600 text-sm md:text-base line-height-3 mb-4" style={{ maxWidth: "560px" }}>
                Forum alanımızda sorularınızı sorabilir, diğer kullanıcıların sorularına yanıt vererek deneyim ve bilgi
                paylaşımında bulunabilirsiniz.
              </p>
              <Button
                className="p-button-outlined"
                label="Foruma Git"
                icon="pi pi-arrow-right"
                iconPos="right"
                onClick={() => navigate("/app/forum-homepage")}
              />
            </div>
            <div className="col-12 lg:col-6 flex justify-content-center">
              <img
                src="images/landing-page/forum-page.jpg"
                className="w-full max-w-26rem border-round-xl shadow-2"
                alt="Forum"
                loading="lazy"
              />
            </div>
          </div>

          {/* Module 2: AI Chat */}
          <div className="grid align-items-center mb-5 surface-card border-1 surface-border border-round-2xl p-3 sm:p-5 shadow-1">
            <div className="col-12 lg:col-6 flex justify-content-center order-2 lg:order-1 mb-3 lg:mb-0">
              <img
                src="/images/landing-page/yz-sohbet.jpg"
                className="w-full max-w-26rem border-round-xl shadow-2"
                alt="Yapay Zeka Sohbet"
                loading="lazy"
              />
            </div>
            <div className="col-12 lg:col-6 text-center lg:text-left order-1 lg:order-2">
              <div
                className="inline-flex align-items-center justify-content-center bg-yellow-100 border-round-xl mb-3"
                style={{ width: "3.5rem", height: "3.5rem" }}
              >
                <i className="pi pi-globe text-3xl text-yellow-700"></i>
              </div>
              <h3 className="text-900 text-2xl font-bold mb-2">Merkez ile Yapay Zeka Sohbeti</h3>
              <p className="text-600 text-sm md:text-base line-height-3 mb-4" style={{ maxWidth: "560px" }}>
                Yapay zeka asistanımız ile OSB mevzuatı, yeşil dönüşüm regülasyonları ve teknolojik yenilikler hakkında anında yanıtlar alın.
              </p>
              <Button
                className="p-button-outlined p-button-warning"
                label="Sohbete Başla"
                icon="pi pi-arrow-right"
                iconPos="right"
                onClick={() => navigate("/app/yapay-zeka")}
              />
            </div>
          </div>

          {/* Module 3: Strategic Plan */}
          <div className="grid align-items-center surface-card border-1 surface-border border-round-2xl p-3 sm:p-5 shadow-1">
            <div className="col-12 lg:col-6 text-center lg:text-left mb-3 lg:mb-0">
              <div
                className="inline-flex align-items-center justify-content-center bg-blue-100 border-round-xl mb-3"
                style={{ width: "3.5rem", height: "3.5rem" }}
              >
                <i className="pi pi-briefcase text-3xl text-blue-700"></i>
              </div>
              <h3 className="text-900 text-2xl font-bold mb-2">Stratejik Plan Çalışması</h3>
              <p className="text-600 text-sm md:text-base line-height-3 mb-4" style={{ maxWidth: "560px" }}>
                Kurumsal hedefleriniz doğrultusunda rehberlik alabilir, stratejik planlama süreci, yol haritaları ve uygulama yöntemlerini inceleyebilirsiniz.
              </p>
              <Button
                className="p-button-outlined"
                label="Planı İncele"
                icon="pi pi-arrow-right"
                iconPos="right"
                onClick={() => navigate("/app/stratejik-plan")}
              />
            </div>
            <div className="col-12 lg:col-6 flex justify-content-center">
              <img
                src="images/landing-page/stratejik-plan-page.jpg"
                className="w-full max-w-26rem border-round-xl shadow-2"
                alt="Stratejik Plan"
                loading="lazy"
              />
            </div>
          </div>
        </section>

        {/* Clean Responsive Footer */}
        <footer
          style={{
            background: "#0f3c54",
            color: "#fff",
            padding: "3rem 1.5rem 1.5rem"
          }}
        >
          <div className="max-w-7xl mx-auto">
            <div className="grid">
              <div className="col-12 md:col-6 lg:col-5 mb-4">
                <h4 className="font-bold text-xl mb-3 text-white">İletişim Bilgileri</h4>
                <div className="flex align-items-start mb-2 text-sm text-blue-100">
                  <i className="pi pi-map-marker mr-2 mt-1 text-primary-200"></i>
                  <span>TOBB İkiz Kuleleri C Kule 16. Kat, Mustafa Kemal Mah. Eskişehir Yolu 9. Km, No: 252 Çankaya / Ankara</span>
                </div>
                <div className="flex align-items-center mb-2 text-sm text-blue-100">
                  <i className="pi pi-phone mr-2 text-primary-200"></i>
                  <a href="tel:+903124191800" className="text-white hover:underline">(312) 419 18 00</a>
                </div>
                <div className="flex align-items-center mb-2 text-sm text-blue-100">
                  <i className="pi pi-envelope mr-2 text-primary-200"></i>
                  <a href="mailto:info@osbuk.org.tr" className="text-white hover:underline">info@osbuk.org.tr</a>
                </div>
                <div className="flex align-items-center text-sm text-blue-100">
                  <i className="pi pi-inbox mr-2 text-primary-200"></i>
                  <span>KEP: osbuk@hs01.kep.tr</span>
                </div>
              </div>

              <div className="col-12 sm:col-6 lg:col-3 mb-4">
                <h4 className="font-bold text-xl mb-3 text-white">Faydalı Bağlantılar</h4>
                <ul className="list-none p-0 m-0">
                  <li className="mb-2">
                    <a href="https://osbuk.org/" target="_blank" rel="noopener noreferrer" className="text-blue-100 hover:text-white text-sm flex align-items-center gap-1">
                      <span>OSBÜK Resmi Web Sitesi</span>
                      <i className="pi pi-external-link text-xs"></i>
                    </a>
                  </li>
                  <li className="mb-2">
                    <a href="https://www.sanayi.gov.tr/" target="_blank" rel="noopener noreferrer" className="text-blue-100 hover:text-white text-sm flex align-items-center gap-1">
                      <span>Sanayi ve Teknoloji Bakanlığı</span>
                      <i className="pi pi-external-link text-xs"></i>
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col-12 sm:col-6 lg:col-4 mb-4">
                <h4 className="font-bold text-xl mb-3 text-white">Bizi Takip Edin</h4>
                <div className="flex gap-3 mb-4">
                  <a href="https://www.facebook.com/OSBustkurulusu/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-primary-200" aria-label="Facebook">
                    <i className="pi pi-facebook text-2xl"></i>
                  </a>
                  <a href="https://x.com/osbuk_org" target="_blank" rel="noopener noreferrer" className="text-white hover:text-primary-200" aria-label="Twitter">
                    <i className="pi pi-twitter text-2xl"></i>
                  </a>
                  <a href="https://www.instagram.com/osbuk_org/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-primary-200" aria-label="Instagram">
                    <i className="pi pi-instagram text-2xl"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/osbukorg/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-primary-200" aria-label="LinkedIn">
                    <i className="pi pi-linkedin text-2xl"></i>
                  </a>
                  <a href="https://www.youtube.com/channel/UCIR6PiBQljY-q-njnYbEi1w" target="_blank" rel="noopener noreferrer" className="text-white hover:text-primary-200" aria-label="YouTube">
                    <i className="pi pi-youtube text-2xl"></i>
                  </a>
                </div>
                <div className="text-xs text-blue-200">
                  © {new Date().getFullYear()} Organize Sanayi Bölgeleri Üst Kuruluşu (OSBÜK). Tüm hakları saklıdır.
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default LandingPage;
